import React, { useEffect, useState } from 'react';
import { Person } from 'type/contact';
import styles from './index.module.scss';
import ContactCard from 'component/ContactCard';
import noContactImg from 'asset/image/kts_ addressbook.png';
import { getAdressConfig } from 'util/approval';
import { getCompanyId } from 'data/storage';
import MemberTree from './MemberTree';
import tracker from 'lib/tracker';

interface IProps {
  className?: string;
  personList: any[];
  selectPerson?: Person[];
  disablePerson?: Person[];
  noPersonText?: string;
  checkbox?: boolean; // 勾选
  checkAll?: boolean; // 全选
  deleteIcon?: boolean; // 删除
  checkedClick?: (person: Person) => void;
  unCheckedClick?: (person: Person) => void;
  deleteIconClick?: (person: Person) => void;
  onScroll?: (e: any) => void;
  type?: string;
  labelId?: number;
  contactCard?: boolean; // 点击弹出卡片
  setShowPopover?: (show: boolean) => void;
  showLetter?: boolean; // 显示字母
}

const OrganizationList: React.FunctionComponent<IProps> = ({ personList = [], type, labelId, contactCard = false, setShowPopover }) => {
  const [showAdress, setShowAdress] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [contactInfo, setContactInfo] = useState<Person>();
  const [organizationList, setOrganizationList] = useState<Person[]>([]);

  useEffect(() => {
    const companyId = getCompanyId();
    getAdressConfig(companyId).then((config) => {
      setShowAdress(config);
    });
    setOrganizationList(personList[0]);
  }, [personList]);

  const showContactCard = (contact: any) => {
    tracker?.reporteContactOperation('查看联系人');
    setContactInfo(contact);
    setShowCard(true);
    setShowPopover && setShowPopover(false);
  };

  const closeContactCard = () => {
    setShowCard(false);
  };

  return (
    <>
      {showAdress ? (
        <>
          {organizationList ? (
            <MemberTree onNodeClick={showContactCard} data={organizationList} />
          ) : (
            <div className={styles.noContact}>
              <img src={noContactImg} className={styles.noContactImg}></img>
              <div className={styles.noContactText}>暂无联系人</div>
            </div>
          )}
          {contactInfo && (
            <ContactCard show={showCard && contactCard} handelClose={closeContactCard} contactInfo={contactInfo} type={type || ''} labelId={labelId || 0} />
          )}
        </>
      ) : (
        <div className={styles.noContact}>
          <img src={noContactImg} className={styles.noContactImg}></img>
          <div className={styles.noContactText}>管理员未公开组织架构</div>
        </div>
      )}
    </>
  );
};

export default OrganizationList;
